var _path, _path2, _path3, _path4, _path5, _circle, _path6, _ellipse, _circle2, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOnboardingTip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#93C9FF",
    d: "M0 0H48V48H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.667H36V29.5003H12V18.667Z",
    fill: "#2B0EAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34.5C30.6274 34.5 36 32.2614 36 29.5C36 26.7386 30.6274 24.5 24 24.5C17.3726 24.5 12 26.7386 12 29.5C12 32.2614 17.3726 34.5 24 34.5Z",
    fill: "#2B0EAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 8.83301L4.5 17.083C3.83333 17.4163 3.83333 18.333 4.5 18.6663L23.25 26.9163C23.75 27.083 24.25 27.083 24.75 26.9163L43.5 18.6663C44.1667 18.333 44.1667 17.4163 43.5 17.083L24.75 8.83301C24.25 8.58301 23.75 8.58301 23.25 8.83301Z",
    fill: "#2255EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17L8 20V33.75",
    stroke: "#2B0EAF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 35,
    r: 2,
    fill: "#2B0EAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H9L10 40H6L7 35Z",
    fill: "#2B0EAF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 40,
    rx: 2,
    ry: 1,
    fill: "#2B0EAF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 7,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2182 36.4798C30.9273 36.2399 30.9273 35.7601 31.2182 35.5202L34.1273 33.121C34.4869 32.8245 35 33.1066 35 33.6009V38.3991C35 38.8934 34.4869 39.1755 34.1273 38.879L31.2182 36.4798zM36.2182 36.4798C35.9273 36.2399 35.9273 35.7601 36.2182 35.5202L39.1273 33.121C39.4869 32.8245 40 33.1066 40 33.6009V38.3991C40 38.8934 39.4869 39.1755 39.1273 38.879L36.2182 36.4798z",
    fill: "#28A443"
  })));
}

export default SvgOnboardingTip;